import React from 'react';
import { heroSliderPropTypes } from './HeroSliderPropTypes';
import Slider from '@App/common/components/Slider/Slider';
import * as styles from './HeroSlider.module.scss';
const HeroSlider = _ref => {
  let {
    slides,
    config
  } = _ref;
  return /*#__PURE__*/React.createElement(Slider, {
    classname: styles.root,
    config: config,
    slides: slides
  });
};
export default HeroSlider;